import { Grid, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React from "react";

const useStyles = makeStyles((theme) => ({
  topSkeleton: {
    width: "102.7%",
    height: 60,
    [theme.breakpoints.up("md")]: {
      marginLeft: "-20px",
    },
    [theme.breakpoints.down("sm")]: {
      margin: "2em 0em 0em -1.6em",
    },
  },
  cardSkeleton: {
    marginTop: "15px",
    width: "100%",
    height: 500,
    [theme.breakpoints.down("sm")]: {
      margin: "2em 0em 0em -1.6em",
    },
  },
}));

function LoadingLayout() {
  const classes = useStyles();

  return (
    <div className="skelton-wrapper">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <Skeleton
            variant="rectangular"
            animation="wave"
            className={classes.topSkeleton}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Skeleton
            variant="rectangular"
            animation="wave"
            className={classes.cardSkeleton}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Skeleton
            variant="rectangular"
            animation="wave"
            className={classes.cardSkeleton}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Skeleton
            variant="rectangular"
            animation="wave"
            className={classes.cardSkeleton}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={500}
            animation="wave"
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default LoadingLayout;
